import React, { useEffect } from 'react';

import Breadcrumb from '../UI/breadcrumb';

import session from 'containers/App/session';
import recommendationsCountModule from 'containers/App/data/endpoints/roomRecommendationsCountByDay';
import { FEATURES } from 'utils/permissions';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'utils/dayjs';

const DayViewBreadcrumb = ({ currentDate }) => {
    const dispatch = useDispatch();

    const propertyId = useSelector(session.selectors.selectSelectedPropertyId);
    const accessibleFeatures = useSelector(session.selectors.selectAccessibleFeatures);
    const recommendationCounts = useSelector(recommendationsCountModule.selectors.selectState);

    const canViewCardinalRecommendations = accessibleFeatures.includes(FEATURES.cardinalRecommendations);
    const canViewAERecs = accessibleFeatures.includes(FEATURES.viewAERecs);

    const dateDisplayFormat = 'dddd DD MMMM YYYY';
    const currentDateLabel = currentDate.format(dateDisplayFormat);

    const fetchData = () => {
        if ((canViewCardinalRecommendations || canViewAERecs)) {
            dispatch(
                recommendationsCountModule.actions.fetch(
                    propertyId,
                    currentDate.format('YYYY-MM-DD'),
                    currentDate.format('YYYY-MM-DD'),
                ),
            );
        }
    };

    useEffect(() => {
        fetchData();
    }, [propertyId, currentDate]);

    const recommendation = (recommendationCounts.data || []).find(
        (row) => row.stayDate === currentDate.format('YYYY-MM-DD'),
    );
    const hasRecommendation =
        currentDate.isSameOrAfter(dayjs(), 'day') &&
        recommendation !== undefined &&
        recommendation.recommendationsCount > 0;

    return (
        <Breadcrumb
            currentPeriodLabel={currentDateLabel}
            showCalendarLink={(canViewCardinalRecommendations || canViewAERecs)}
            calendarDate={currentDate.format('YYYY-MM-DD')}
            calendarHasRecommendation={hasRecommendation}
        />
    );
};

export default DayViewBreadcrumb;
